import { toFilter } from 'utils/widgetUtil'
import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { DecoratedSearchFilterComposingStrategy } from './strategy/searchFilterComposing/decorator/type'

export const composeDecoratedDetailSearchFilter = (
  strategy: DecoratedSearchFilterComposingStrategy,
  widgetSetting: DashboardWidgetType,
  insights: InsightData[],
  pivots: InsightData[]
) => strategy.composeDetailSearchFilter(toFilter(widgetSetting), insights, pivots, widgetSetting)

export default composeDecoratedDetailSearchFilter
